import { useScrolled } from "../../hooks/useScrolled";
import { NAV_LINKS } from "../../utils/constants";
import NavbarTemplate from "./NavbarTemplate";

export function scrollToSection(id) {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
}

export default function Navbar() {
  const scrolled = useScrolled();

  return (
    <NavbarTemplate
      scrolled={scrolled}
      navLinks={NAV_LINKS}
      onNavClick={(item) => scrollToSection(item.id)}
      onCtaClick={() => scrollToSection("contact")}
    />
  );
}
